import React from 'react';
import { Toast } from 'react-bootstrap';
import { AlertTriangle } from 'lucide-react';

export default class ErrorToast extends React.Component {

    render() {

        let text = this.props.error.statusText;
        if (this.props.error.data) {
            if (typeof this.props.error.data === 'string') {
                text = this.props.error.data;
            } else {
                if (this.props.error.projectId) {
                    text = this.props.error.projectId + " not found."
                } else {
                    text = this.props.error.data.title
                }
            }
        }

        return (
            <Toast
                onClose={() => this.props.onClose(this.props.error)}
                show={true}>
                <Toast.Header style={{ backgroundColor: "#EA4335", color: "white" }}>
                    <AlertTriangle />
                    {/* <strong className="mr-auto" style={{ paddingLeft: "0.5rem" }}> ERROR {this.props.error.status}</strong> */}
                    <strong className="mr-auto" style={{ paddingLeft: "0.5rem" }}>{this.props.error.statusText}</strong>
                </Toast.Header>
                {/* <Toast.Body>{this.props.error.data}</Toast.Body> */}
                <Toast.Body>{text}</Toast.Body>
            </Toast>);
    }
};
